"use strict";
//import oneCoastComp1 from 'emun.salesrep/oneCoastComp1'

function custom(mod) {
  //mod.component('oneCoastComp1', oneCoastComp1);
}

export default custom;